import * as SampleStatisticsConstants from './SampleStatisticsConstants';
import AppService from 'Global/AppService';


const addDeviceToSampleStatsReducerState = (instanceId) => {
	return {
		type: SampleStatisticsConstants.SAMPLE_STAT_DATA_STATE_ADD,
		payload: instanceId
	}
};

const removeDeviceToSampleStasReducerState = (instanceId) => {
	return {
		type: SampleStatisticsConstants.SAMPLE_STAT_DATA_STATE_REMOVE,
		payload: instanceId
	}
};

const getSampleStatsData = (url,deviceId,load) => {
	
	return (dispatch) => {
		dispatch({ type: SampleStatisticsConstants.SAMPLE_STATISTICS_DATA_FETCHING,payload:deviceId });

		function callback(success, err) {
			
			if (success && success.result) {
				dispatch(getSampleStatsDataSuccess(success,deviceId));
			} else {
				dispatch(getSampleStatsDataFailure(deviceId));
			}
		}

		AppService.postData(load,url,callback);
	}
}

const getSampleStatsDataSuccess = (successResponse,deviceId) => {
	return { type: SampleStatisticsConstants.SAMPLE_STATISTICS_DATA_FETCHED, payload:{newState: successResponse,deviceId:deviceId} };
}

const getSampleStatsDataFailure = (deviceId) => {
	return { type: SampleStatisticsConstants.SAMPLE_STATISTICS_DATA_FETCHING_FAILED,payload:deviceId };
}

export{
    getSampleStatsData,
	addDeviceToSampleStatsReducerState,
	removeDeviceToSampleStasReducerState
}